import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material'
import React from 'react'

import ToothGraphic2 from '@/assets/images/Tooth-graphic-2.svg'
import Chip from '@/components/Chip'
import { isNullorEmpty } from '@/utils'
import { pieChartSections } from '@/utils/constants'

type StumpShadePDFProps = {
  recipeOutput: any
  brand: string
}

const TableHeader = ({ text, sx }: { text: string; sx?: any }) => (
  <TableCell
    sx={{
      p: '16px',
      textAlign: 'left',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.17px',
      fontWeight: '700',
      color: 'black',
      borderBottom: 'none',
      ...sx,
    }}
  >
    {text}
  </TableCell>
)

const TableData = ({ value }: { value: string | undefined }) => (
  <TableCell
    sx={{
      p: '16px',
      textAlign: 'left',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.17px',
      fontWeight: '400',
      color: 'black',
      borderBottom: 'none',
    }}
  >
    {value ? `${value}` : '-'}
  </TableCell>
)

const EnamelPdf = ({ recipeOutput, brand }: StumpShadePDFProps) => {
  const theme = useTheme()

  return (
    <Box
      display="flex"
      mt={1}
      // height="100%"
      sx={{
        color: 'black',
        borderBottom: '1px solid #000',
        marginBottom: '8px',
        background: 'white',
      }}
    >
      <Box sx={{ width: '30%' }}>
        <img
          style={{ width: '270px', height: '380px' }}
          src={ToothGraphic2}
          alt="Toothimage"
        />
      </Box>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="start"
        height="100%"
        sx={{
          color: 'black',
          backgroundColor: '#F8F9FA',
          padding: '16px',
        }}
      >
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          alignItems="center"
          my={2}
          gap={1}
        >
          <Typography
            sx={{ fontSize: '1.5rem', fontWeight: 500, color: '#000' }}
          >
            Enamel:
          </Typography>
          {isNullorEmpty(brand) && (
            <Chip
              label={brand}
              sx={{
                bgcolor: theme.palette.background.chip,
                fontSize: '16px',
                color: theme.palette.common.black,
                '&:hover': {
                  bgcolor: theme.palette.background.chip,
                },
              }}
            />
          )}
        </Box>

        <Box sx={{ pl: 5, paddingBottom: '16px', width: '100%' }}>
          <Table
            sx={{
              width: '100%',
              borderCollapse: 'unset',
            }}
          >
            <TableBody sx={{ width: '100%' }}>
              <TableRow>
                <TableHeader text="" sx={{ width: '30%' }} />
                {pieChartSections?.map(({ key, label }) => (
                  <React.Fragment key={key}>
                    <TableHeader text={label} />
                  </React.Fragment>
                ))}
              </TableRow>
              <TableRow>
                <TableHeader text="Enamel" />
                {pieChartSections?.map(({ key }) => {
                  const chartDetail =
                    recipeOutput?.[`enameloptions_${key}`] || ''
                  return (
                    <React.Fragment key={key}>
                      <TableData value={chartDetail} />
                    </React.Fragment>
                  )
                })}
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Box>
  )
}

export default EnamelPdf
